/**
 * UISelectSegmentPassengers
 * 
 * Options:
 *     onPassengerSelected(data, that):                        function - Callback, called when passenger had item selected.
 *     onPassengerFocused(data, initialize_selection, that):   function - Callback, called when passenger was focused. `initialize_selection` is boolean variable defining whether item selection should be initialized on this focus.
 *     onPassengerReset(data, call_callback_after, that):      function - Callback, called when passenger's selection was reset - either individually, or on the whole segment selections reset.
 *
 *     afterPassengerSelected(data, that):                     function - Callback, called after passenger's selection was handled. Use it to control autofocus rules.
 *     afterPassengerReset(data, that):                        function - Callback, called after passenger's selection was reset. Use it to control autofocus rules.
 *     afterSegmentReset(segment_id, that):                    function - Callback, called after serment reset. Use it to control autofocus rules.
 */
var UISelectSegmentPassengers = (function ($) {

    UISelectSegmentPassengers = function (options) {
        var that = this;

        that.$segment = options['$wrapper'] || null;
        that.$container = options['$container'] || $.sa.$document; // DOM-element containing all related segments

        if (that.$segment && that.$segment.length) {
            // DOM
            that.$segments_all = that.$container.find(that.selectors.select_segment_passengers);
            that.$segment_price = that.$segment.find(that.selectors.select_segment_price);
            that.$segment_expand_button = that.$segment.find(that.selectors.select_segment_passenger_expand_button);

            // CONST
            that.type = options['type'] || that.getSegmentTypes();
            that.all_in_one = options['all_in_one'] || that.isAllInOne();
            that.segment_id = options['segment_id'] || that.getSegmentId(); // not for all-in-one mode
            that.prices = that.getPassengerPrices(); // for all-in-one mode only
            that.currency = options['segment_currency'] || that.getSegmentCurrency();
            that.collapse_on_select_all = (options['collapse_on_select_all'] !== undefined) ? !!options['collapse_on_select_all'] : true;
            that.select_on_init = (options['select_on_init'] !== undefined) ? !!options['select_on_init'] : true;
            that.params = options['params'] || null;  // Дополнительные данные, которые хотим хранить вместе с экземпляром класса в виде объекта { key: value }

            // DYNAMIC VARS

            // HANDLERS
            that.onPassengerSelected = (options['onPassengerSelected'] || function () {});
            that.onPassengerFocused = (options['onPassengerFocused'] || function () {});
            that.onPassengerReset = (options['onPassengerReset'] || function () {});

            that.afterPassengerSelected = (options['afterPassengerSelected'] || function () {});
            that.afterPassengerReset = (options['afterPassengerReset'] || function () {});
            that.afterSegmentReset = (options['afterSegmentReset'] || function () {});

            // INIT
            that.init(options);
        }
    };

    UISelectSegmentPassengers.prototype.TYPES = {
        button: 'button',
        checkbox: 'checkbox',
        counter: 'counter',
        switch: 'switch'
    };

    UISelectSegmentPassengers.prototype.TYPE_COUNTER_SETTINGS_DEFAULT = {
        min: 0,
        value: 0
    };

    UISelectSegmentPassengers.prototype.class = {
        segment_current: 'current',
        segment_expanded: 'is-active',
        segment_disabled: 'disabled',
        segment_toggle_disabled: 'toggle-disabled',
        passenger_selected: 'selected',
        passenger_focused: 'focused',
        passenger_disabled: 'disabled',

        passenger_unremovable: 'js-unremovable',

        badge_selected_classes: 'fill violet item-selected js-select-passenger-selected-item',
        badge_selected_text_classes: 'js-select-passenger-selected-item-text',
        badge_empty_desktop_classes: 'fill gray light select-passenger-action js-select-passenger-action-select',
        badge_empty_mobile_classes: 'coral select-passenger-action js-select-passenger-action-select',
        badge_unremovable_classes: 'fill cyan item-unremovable',
        badge_unremovable_text_classes: 'js-select-passenger-unremovable-item-text',
    };

    UISelectSegmentPassengers.prototype.selectors = {
        select_segment_passengers: '.js-select-segment-passengers',
        select_segment_passenger_expand_button: '.js-accordion-button',
        select_segment_price: '.js-select-segment-price',
        select_passengers: '.js-select-passengers',
        select_passenger: '.js-select-passenger',
        select_passenger_actions: '.js-select-passenger-actions',
        select_passenger_badge: '.js-select-passenger-badge',
        select_passenger_badge_text: '.js-select-passenger-badge-text',
        select_passenger_badge_reset_btn: '.js-select-passenger-badge-reset-btn',
        select_passenger_selected_item: '.js-select-passenger-selected-item',
        select_passenger_selected_item_text: '.js-select-passenger-selected-item-text',
        select_passenger_counter: '.js-select-passenger-counter',
        select_passenger_switch: '.js-select-passenger-switch',
        select_passenger_switch_checkbox: '.js-select-passenger-switch-checkbox',
        select_passenger_wrap_action_select: '.js-select-passenger-wrap-action-select',
        select_passenger_action_select: '.js-select-passenger-action-select',
        select_passenger_action_reset: '.js-select-passenger-action-reset',
        select_passengers_actions: '.js-select-passengers-actions',
        select_passengers_action_reset: '.js-select-passengers-action-reset',
    };

    UISelectSegmentPassengers.prototype.selectors.select_segment_current = UISelectSegmentPassengers.prototype.selectors.select_segment_passengers +
        '.' + UISelectSegmentPassengers.prototype.class.segment_current;
    UISelectSegmentPassengers.prototype.selectors.select_passenger_selected = UISelectSegmentPassengers.prototype.selectors.select_passenger +
        '.' + UISelectSegmentPassengers.prototype.class.passenger_selected;

    UISelectSegmentPassengers.prototype.data_keys = {
        select_passenger_id: 'passenger-id',
        select_passenger_segment_id: 'segment-id',
        select_passenger_price: 'price',
        select_passenger_quantity: 'quantity',
        select_passenger_firstname: 'passenger-firstname',
        select_passenger_lastname: 'passenger-lastname',
        select_passenger_category_code: 'passenger-category-code',
        select_passenger_host_id: 'passenger-host-id',
        select_passenger_host_parent_id: 'passenger-host-parent-id',
        select_passenger_host_child_id: 'passenger-host-child-id',
        select_passenger_is_subscriber: 'passenger-is-subscriber',
        select_passenger_ids: 'passenger-ids',
        select_passenger_price_item: 'price-',
        select_passenger_currency_item: 'currency-',

        select_passenger_counter_min: 'min',
        select_passenger_counter_max: 'max',
        select_passenger_counter_value: 'value',

        select_segment_id: 'segment-id',
        select_segment_currency: 'segment-currency',
        select_segment_type: 'type',
        select_segment_all_in_one: 'all-in-one',
        select_segment_ids: 'segment-ids',
        select_segment_is_transfer: 'is-transfer-segment',
        select_segment_direction_index: 'direction-index',

        selection_id: 'item-id',
        selection_price: 'item-price',
        selection_currency: 'item-currency',
    };

    UISelectSegmentPassengers.prototype.init = function (options = {}) {
        var that = this;

        that.initEventHandlers();

        // hide "reset all" button by default - before any item selected
        that.hideActionResetAll();

        that.initPassengers(options);

        that.initSegment();
    };

    UISelectSegmentPassengers.prototype.initEventHandlers = function () {
        var that = this;

        // passenger focusing
        that.$segment.on('click', that.selectors.select_passenger_wrap_action_select, function (e) {
            that.focus($(this), true);
        });

        // passenger selection reset
        that.$segment.on('click', that.selectors.select_passenger_action_reset, function (e) {
            // to prevent setting focused on reset click
            e.stopPropagation();
            // search through whole `passenger` - in case when reset control is not inside the selected item
            var $selected_item = that.getPassengerSelection($(this).parents(that.selectors.select_passenger));
            that.reset($selected_item);
        });

        // all segment passenger selections reset
        that.$segment.on('click', that.selectors.select_passengers_action_reset, function (e) {
            that.resetSegment();
        });

        // re-render empty badges on resize
        if (that.isType(that.TYPES.button)) {
            $.sa.$window.on('resize', function (e) {
                var $select_passenger_unselected = that.getSegmentPassengersUnselected();
                $select_passenger_unselected.each(function () {
                    that.__renderPassengerBadge($(this), 'empty');
                });
            });
        }
    };

    UISelectSegmentPassengers.prototype.initSegment = function () {
        var that = this;

        // set initial prices to segments
        that.setSegmentPrice(that.countSegmentPrice());

        // if all passengers in segment are selected - collapse segment
        // (except of disabled segments - disabled segments should not be collapsed)
        if (
            !that.isType(that.TYPES.counter) && 
            !that.getFirstUnselectedSegmentPassenger().length && 
            !that.isSegmentDisabled() &&
            that.collapse_on_select_all
        ) {
            that.collapseSegment();
        }
    };

    UISelectSegmentPassengers.prototype.initPassengers = function (options) {
        var that = this,
            items_paid = options['items_paid'] || [],
            items_unpaid = options['items_unpaid'] || [],
            $select_passengers_all = that.getSegmentPassengersAll();

        /**
         * If item for current passenger is selected and paid:
         * show selection only, set it unremovable
         * 
         * @param {Object} selected_item_data Data of selection
         */
        var initSelectionPaid = function (selected_item_data) {
            that.setPassengerValue(selected_item_data, false);
            // do not apply selection - paid items shouldn't be submitted
        };

        /**
         * If item for current passenger is selected and unpaid:
         * show selection, set it removable, apply selection
         * 
         * @param {Object} selected_item_data Data of selection
         * @param {jQuery} $select_passenger Passenger on which selection should be applied
         */
        var initSelectionUnpaid = function (selected_item_data, $select_passenger) {
            that.setPassengerValue(selected_item_data, true);
            if (that.select_on_init) {
                that.applySelection($select_passenger);
            }
        };

        $select_passengers_all.each(function () {
            var $select_passenger = $(this),
                passenger_id = that.getPassengerId($select_passenger),
                // paid items belonging to current passenger
                passenger_selected_items_paid = items_paid.filter(item_data =>
                    that.isThatSegment(item_data.segment_id) &&
                    that.isTheSamePassenger(passenger_id, item_data.passenger_id) &&
                    that.isSelectionRelatesToPassenger($select_passenger, item_data.item_id)
                ),
                // unpaid items belonging to current passenger
                passenger_selected_items_unpaid = items_unpaid.filter(item_data =>
                    that.isThatSegment(item_data.segment_id) &&
                    that.isTheSamePassenger(passenger_id, item_data.passenger_id) &&
                    that.isSelectionRelatesToPassenger($select_passenger, item_data.item_id)
                );

            // INITIALIZE CONTROLS
            that.initPassengerControls($select_passenger);

            // SET INITIAL VALUES
            if (passenger_selected_items_paid.length || passenger_selected_items_unpaid.length) {
                if (!that.isAllInOne()) {
                    // (PAID MUST BE SET BEFORE UNPAID - TO SET LIMITS FOR COUNTERS)
                    if (passenger_selected_items_paid.length) {
                        passenger_selected_items_paid.forEach(function (selected_item_data) {
                            initSelectionPaid(selected_item_data);
                        });
                    }
                    if (passenger_selected_items_unpaid.length) {
                        passenger_selected_items_unpaid.forEach(function (selected_item_data) {
                            initSelectionUnpaid(selected_item_data, $select_passenger);
                        });
                    }
                }
                // for all-in-one mode: pick only one item of both paid and unpaid items, and apply select() on them
                else {
                    if (passenger_selected_items_paid.length) {
                        initSelectionPaid(passenger_selected_items_paid[0]);
                    }
                    if (passenger_selected_items_unpaid.length) {
                        initSelectionUnpaid(passenger_selected_items_unpaid[0], $select_passenger);
                    }
                }
            }
            // if initial value for current passenger is not passed:
            // check template, if value is set there - apply it
            else {
                if (that.select_on_init) {
                    that.applySelection($select_passenger);
                }
            }
        });
    };

    /**
     * @param {Boolean} is_removable Whether that selection might be removed
     * @param {Object} selected_item_data Format:
     *  {
     *      segment_id: {string|int}             id of segment,
     *      passenger_id: {string|int}           id of selected passenger,
     *      item_id: {string|int}                id of selected item (e.g. for Svcs it would be airline_svs_id); if `item_quantity` is 0, this parameter is optional,
     *      item_price: {float}                  price of selected item; for all-in-one mode this parameter is optional,
     *      item_quantity: {int}                 (optional) quantity of selected item; by default it's 1; if it's 0, `reset()` would be applied
     *      item_text: {Object}                  text data of selected item (e.g. for svcs it equals to ssr_text)
     *  }
     */
    UISelectSegmentPassengers.prototype.setPassengerValue = function (selected_item_data, is_removable = true) {
        var that = this,
            item_price = selected_item_data.item_price ? parseFloat(selected_item_data.item_price) : 0,
            item_quantity = selected_item_data.item_quantity ? parseInt(selected_item_data.item_quantity, 10) : 0,
            $select_passenger = that.getPassengerById(selected_item_data.passenger_id);

        if (!that.isThatSegment(selected_item_data.segment_id)) {
            return;
        }

        if (!that.isTheSamePassenger(that.getPassengerId($select_passenger), selected_item_data.passenger_id)) {
            return;
        }

        // if selection id is specified for that passenger, and selected item data does not match it
        if (!that.isSelectionRelatesToPassenger($select_passenger, selected_item_data.item_id)) {
            return;
        }

        if (that.isType(that.TYPES.button)) {
            var item_data = {
                    id: selected_item_data.item_id,
                    price: item_price,
                    text: selected_item_data.item_text || ''
                };

            if (!is_removable) {
                that.setPassengerSelectionUnremovable($select_passenger, item_data);
                that.setPassengerDisabled($select_passenger);
            } else {
                that.setPassengerBadgeValue($select_passenger, item_quantity, item_data);
            }
        }

        if (that.isType(that.TYPES.counter)) {
            // add current counter value to quantity
            var current_value = is_removable
                // if it's removable value - get current counter value, to keep it
                ? that.getPassengerCounterValue(selected_item_data.passenger_id)
                // if it's unremovable value - get current counter min limit, to increase it
                : that.getPassengerCounterMin(selected_item_data.passenger_id);

            item_quantity += current_value;

            // set unremovable before setting value - IMPORTANT
            if (!is_removable) {
                that.setPassengerSelectionUnremovable($select_passenger, {min_value: item_quantity});
            }
            // for paid (unremovable) items - set value into input (because applySelection() will not be called)
            try {
                that.setPassengerCounterValue($select_passenger, item_quantity, !is_removable);
            } catch (e) {
                if (e instanceof CounterValueIsOutOfRangeError) {
                    $.sa.error('Trying to change counter value to the out of range value.');
                } else {
                    $.sa.error(e);
                }
                // if value is out of range - do nothing
                return;
            }
        }

        if (that.isType(that.TYPES.switch)) {
            that.setPassengerSwitchValue($select_passenger, !!item_quantity);
            if (!is_removable) {
                that.setPassengerDisabled($select_passenger);
                that.setPassengerSelectionUnremovable($select_passenger);
            }
        }

        if (that.isType(that.TYPES.checkbox)) {
            // TODO
        }

        // shouldn't set passenger price in all-in-one mode - because it's different for all passengers
        if (!that.isAllInOne()) {
            that.setPassengerPrice($select_passenger, item_price * item_quantity);
        }

        // set passenger quantity (for all-in-one mode it's quantity for one passenger)
        that.setPassengerQuantity($select_passenger, item_quantity);
    };

    UISelectSegmentPassengers.prototype.initPassengerControls = function ($select_passenger) {
        var that = this;

        if (that.isType(that.TYPES.button)) {
            that.__initPassengerButton($select_passenger);
        }
        if (that.isType(that.TYPES.counter)) {
            that.__initPassengerCounter($select_passenger);
        }
        if (that.isType(that.TYPES.switch)) {
            that.__initPassengerSwitch($select_passenger);
        }
    };

    UISelectSegmentPassengers.prototype.setPassengerCounterMax = function (passenger_id, counter_max = null, check_min = true) {
        var that = this;

        var $selection = that.getSelectionByPassengerId(passenger_id);

        if (!$selection || !$selection.length) {
            return;
        }

        if (!that.isType(that.TYPES.counter)) {
            return;
        }

        if (counter_max === null) {
            counter_max = that.getCounterValue($selection);
        }

        that.setCounterMax($selection, counter_max, check_min);
    };

    UISelectSegmentPassengers.prototype.setPassengerCounterMin = function (passenger_id, counter_min = null, check_max = true) {
        var that = this;

        var $selection = that.getSelectionByPassengerId(passenger_id);

        if (!$selection || !$selection.length) {
            return;
        }

        if (!that.isType(that.TYPES.counter)) {
            return;
        }

        that.setCounterMin($selection, counter_min, check_max);
    };

    UISelectSegmentPassengers.prototype.__initPassengerCounter = function ($select_passenger) {
        var that = this,
            passenger_id = that.getPassengerId($select_passenger),
            $counter = that.getPassengerSelection($select_passenger);

        if (!$counter.length) {
            return;
        }

        // init event handlers
        var initCounterEventHandler = function ($select_passenger) {
            $select_passenger.on(UICounter.prototype.custom_events.value_changed, '.js-counter-input', function (e, data) {
                var $counter = $(this).parents(that.selectors.select_passenger_counter),
                    passenger_id = that.getPassengerId($select_passenger),
                    item_id = that.getSelectionId($counter),
                    item_price = that.getSelectionPrice($counter),
                    value = data.value ? parseInt(data.value, 10) : 0,
                    value_diff = data.diff ? parseInt(data.diff, 10) : 0;
                
                if (value_diff > 0 || value !== 0) {
                    that.select(passenger_id, item_id, item_price, {}, value, value_diff);
                } else if (value_diff !== 0) {
                    that.reset($counter);
                }
            });
        };

        var counter_min = that.getPassengerCounterMin(passenger_id) || that.TYPE_COUNTER_SETTINGS_DEFAULT.min,
            counter_max = that.getPassengerCounterMax(passenger_id) || null;

        // set minimum
        that.setPassengerCounterMin(passenger_id, counter_min);

        // set maximum, if needed
        if (null !== counter_max) {
            that.setPassengerCounterMax(passenger_id, counter_max);
        }

        initCounterEventHandler($select_passenger);
    };

    UISelectSegmentPassengers.prototype.__initPassengerSwitch = function ($select_passenger) {
        var that = this,
            $switch = that.getPassengerSelection($select_passenger),
            $switch_checkbox = $switch.find(that.selectors.select_passenger_switch_checkbox);

        $switch_checkbox.on('change', function (e) {
            var $checkbox = $(this),
                $switch = $checkbox.parent(that.selectors.select_passenger_switch),
                value = $checkbox.prop('checked'),
                passenger_id = that.getPassengerId($select_passenger),
                item_id = that.getSelectionId($switch),
                item_price = that.getSelectionPrice($switch);

            if (value) {
                that.select(passenger_id, item_id, item_price);
            } else {
                that.reset($switch);
            }
        });
    };

    UISelectSegmentPassengers.prototype.__initPassengerButton = function ($select_passenger) {
        var that = this;
        if (!that.isPassengerSelected($select_passenger)) {
            // render empty badge by default (before set initial value to passenger)
            that.__renderPassengerBadge($select_passenger, 'empty');
        }
    };

    /**
     * Use only to apply initial value
     * @param $select_passenger
     */
    UISelectSegmentPassengers.prototype.applySelection = function ($select_passenger) {
        var that = this,
            $selection = that.getPassengerSelection($select_passenger),
            passenger_id = that.getPassengerId($select_passenger),
            item_id = that.getSelectionId($selection),
            item_quantity = that.getPassengerQuantity($select_passenger),
            item_price = that.getSelectionPrice($selection),
            selection_value;

        if (that.isType(that.TYPES.counter)) {
            // get value of DATA-ATTRIBUTE (it keeps prepared value to set in the input value)
            selection_value = (typeof $selection.data(that.data_keys.select_passenger_counter_value) !== 'undefined')
                ? parseInt($selection.data(that.data_keys.select_passenger_counter_value), 10)
                : that.TYPE_COUNTER_SETTINGS_DEFAULT.value;

            if (that.getCounterValue($selection) !== selection_value) {
                try {
                    that.setCounterValue($selection, selection_value);
                } catch (e) {
                    $.sa.error(e);
                    // if value is out of range - do nothing
                    return;
                }
            }
        }

        if (that.isType(that.TYPES.switch)) {
            var $selection_input = $selection.find(that.selectors.select_passenger_switch_checkbox);

            selection_value = $selection_input.prop('checked');

            if (selection_value) {
                that.select(passenger_id, item_id, item_price);
            }
        }

        if (that.isType(that.TYPES.button)) {
            // if selection id is set
            if (item_id) {
                // badge text
                var $badge_text = $selection.find(that.selectors.select_passenger_badge_text),
                    item_text = $badge_text.text();

                if (item_quantity > 0) {
                    that.select(passenger_id, item_id, item_price, {item_text: item_text}, item_quantity, item_quantity);
                }
            }
        }

        if (that.isType(that.TYPES.checkbox)) {
            // TODO
        }
    };

    /**
     * Задать список (или конкретное значение) дополнительных параметров
     * @param value
     * @param key {string|null} Если задано, то обновляем значение по этому ключу, иначе веcь объект params
     */
    UISelectSegmentPassengers.prototype.setParams = function (value, key = null) {
        var that = this;

        if (!key) {
            that.params = value;
            return;
        }

        if (!that.params) {
            that.params = {};
        }
        that.params[key] = value;
    };

    /**
     * Получить список (или конкретное значение) дополнительных параметров
     * @param key {string|null} Если задано, то получаем значение по этому ключу, иначе весь объект params
     * @returns {null|*}
     */
    UISelectSegmentPassengers.prototype.getParams = function (key = null) {
        var that = this;

        if (!that.params) {
            return null;
        }

        if (key) {
            if (that.params[key] !== undefined) {
                return that.params[key];
            }
            return null;
        }

        return that.params;
    }

    UISelectSegmentPassengers.prototype.select = function (
        passenger_id,
        item_id,
        item_price,
        item_data = {},
        item_quantity = 1,
        item_quantity_diff = 1,
        call_callback_after = true,
        call_callback = true
    ) {
        var that = this,
            $passenger_selected = that.getPassengerById(passenger_id),
            item_quantity_original,
            item_quantity_unpaid,
            segment_price,
            callback_data,
            callback_data_item_base;

        if (
            that.isPassengerDisabled($passenger_selected) && 
            !that.isSegmentTransfer()
        ) {
            return;
        }

        item_price = parseFloat(item_price);
        item_quantity_original = parseInt(item_quantity, 10);

        // if counter - remove min_limit from quantity value;
        // min_limit - it is paid items
        if (that.isType(that.TYPES.counter)) {
            var counter_min = that.getPassengerCounterMin(passenger_id);
            item_quantity_unpaid = item_quantity_original - counter_min;
        } else {
            item_quantity_unpaid = item_quantity_original;
        }

        if (item_quantity_unpaid <= 0) {
            var $selection = that.getPassengerSelection($passenger_selected);
            that.reset($selection);
            return;
        }

        // set `data-value` and value to counter (in case `select()` was called from outside the component)
        if (that.isType(that.TYPES.counter)) {
            try {
                that.setPassengerCounterValue($passenger_selected, item_quantity_original);
            } catch (e) {
                if (e instanceof CounterValueIsOutOfRangeError) {
                    $.sa.error('Trying to change counter value to the out of range value.');
                } else {
                    $.sa.error(e);
                }
                // if value is out of range - do not continue
                return;
            }
        }

        // set state to switch (in case `select()` was called from outside the component)
        if (that.isType(that.TYPES.switch)) {
            that.setPassengerSwitchValue($passenger_selected, !!item_quantity_original);
        }

        // set passenger selected
        that.setPassengerSelected($passenger_selected);

        // shouldn't set passenger price in all-in-one mode - because it's different for all passengers
        if (!that.isAllInOne()) {
            // set passenger price
            that.setPassengerPrice($passenger_selected, item_price * item_quantity_unpaid);
        }

        // set passenger quantity (for all-in-one mode it's quantity for one passenger)
        that.setPassengerQuantity($passenger_selected, item_quantity_unpaid);

        // and then recalculate segment price (after setting passenger price - IMPORTANT)
        segment_price = that.countSegmentPrice();
        that.setSegmentPrice(segment_price);

        // show selected item in the passenger block
        if (that.isType(that.TYPES.button)) {
            var badge_data = {
                id: item_id,
                price: item_price,
                text: item_data.item_text
            };
            that.__renderPassengerBadge($passenger_selected, 'selected', badge_data);
        }

        callback_data_item_base = Object.assign({}, {
            item_id: item_id,
            currency: that.currency,
            item_quantity: item_quantity_unpaid,
            item_quantity_diff: item_quantity_diff,
        }, item_data);

        if (!that.isAllInOne()) {
            callback_data = Object.assign({},
                callback_data_item_base,
                {
                    item_price: item_price,
                    passenger_id: passenger_id, 
                    segment_id: that.segment_id
                }
            );
        } else {
            // for all-in-one mode callback data is array of objects
            callback_data = [];

            for (var price_attr_name in that.prices) {
                var price_value = that.prices[price_attr_name],
                    attr_name_parts = price_attr_name.split('-'),
                    segment_id_enabled = attr_name_parts[2],
                    passenger_id_enabled = attr_name_parts[3];

                callback_data.push(Object.assign({},
                    callback_data_item_base,
                    {
                        item_price: price_value,
                        passenger_id: passenger_id_enabled,
                        segment_id: segment_id_enabled,
                    }
                ));
            }
        }

        that.showActionResetAll();

        if (call_callback) {
            that.onPassengerSelected(callback_data, that);
        }

        if (call_callback_after) {
            that.afterPassengerSelected(callback_data, that);
        }
    };

    UISelectSegmentPassengers.prototype.focus = function ($select_passenger_wrap, initialize_selection = false) {
        if (!$select_passenger_wrap.length) {
            return;
        }

        var that = this;

        if (that.isPassengerDisabled($select_passenger_wrap)) {
            return;
        }

        var $segment_current = that.$container.find(that.selectors.select_segment_current),
            $select_passenger_all = that.$container.find(that.selectors.select_passenger),
            segment_current_id = $segment_current.length ? that.getSegmentId($segment_current) : null,
            passenger_id = that.getPassengerId($select_passenger_wrap);

        // remove focused state from all passengers
        that.unsetPassengerFocused($select_passenger_all);

        // if that segment is not current - set it current automatically on focus
        if (!segment_current_id || !that.isThatSegment(segment_current_id)) {
            // unset previously current segment 
            that.unsetSegmentCurrent($segment_current);
            // set that segment current
            that.setSegmentCurrent();
        }

        that.setPassengerFocused($select_passenger_wrap);

        var callback_data = {
            segment_id: that.segment_id, 
            passenger_id: passenger_id,
            passenger_data: {
                host_id: that.getPassengerHostId($select_passenger_wrap),
                host_parent_id: that.getPassengerHostParentId($select_passenger_wrap),
                host_child_id: that.getPassengerHostChildId($select_passenger_wrap),
                category_code: that.getPassengerCategoryCode($select_passenger_wrap),
                literals: that.__getPassengerLiterals($select_passenger_wrap)
            }
        };

        that.onPassengerFocused(callback_data, initialize_selection, that);

        // if segment is collapsed - expand it
        if (!that.isSegmentExpanded()) {
            // TODO: collapse others
            that.expandSegment();
        }
    };

    UISelectSegmentPassengers.prototype.reset = function ($selection, call_callback_after = true, call_callback = true) {
        var that = this,
            $passenger = $selection.parents(that.selectors.select_passenger),
            passenger_id = that.getPassengerId($passenger),
            selection_id = that.getSelectionId($selection),
            selection_text = that.getSelectionText($selection),
            passenger_price = that.getPassengerPrice($passenger),
            passenger_quantity = that.getPassengerQuantity($passenger),
            passenger_quantity_min = that.isType(that.TYPES.counter) ? that.getPassengerCounterMin(passenger_id) : 0,
            segment_price,
            callback_data,
            callback_data_item_base;

        if (
            that.isPassengerDisabled($passenger) &&
            !that.isSegmentTransfer()
        ) {
            return;
        }

        // clear all passenger state modifiers
        that.clearPassenger($passenger);

        // shouldn't set passenger price in all-in-one mode - because it's different for all passengers
        if (!that.isAllInOne()) {
            // clear passenger price (before recalculating - IMPORTANT)
            that.setPassengerPrice($passenger, 0);
        }

        // recalculate segment price
        // if it's all-in-one, just set 0
        segment_price = !that.isAllInOne() ? that.countSegmentPrice() : 0;
        that.setSegmentPrice(segment_price);

        // clear passenger quantity
        that.setPassengerQuantity($passenger, 0);

        // remove selected item from passenger block
        if (that.isType(that.TYPES.button)) {
            that.__renderPassengerBadge($passenger, 'empty');
        }

        // set `data-value` and value to counter (in case `reset()` was called from outside the component)
        if (that.isType(that.TYPES.counter)) {
            that.setPassengerCounterValue($passenger, passenger_quantity_min);
        }

        // set state to switch (in case `reset()` was called from outside the component)
        if (that.isType(that.TYPES.switch)) {
            that.setPassengerSwitchValue($passenger, false);
        }

        callback_data_item_base = {
            item_id: selection_id,
            item_price: passenger_price,
            currency: that.currency,
            item_quantity: 0,
            item_quantity_diff: (passenger_quantity !== 0) ? -passenger_quantity : 0,
        };

        if (undefined !== selection_text) {
            callback_data_item_base['item_text'] = selection_text;
        }

        if (!that.isAllInOne()) {
            callback_data = Object.assign({},
                callback_data_item_base,
                {
                    passenger_id: passenger_id, 
                    segment_id: that.segment_id
                }
            );
        } else {
            // for all-in-one mode callback data is array of objects
            callback_data = [];

            for (var price_attr_name in that.prices) {
                var price_value = that.prices[price_attr_name],
                    attr_name_parts = price_attr_name.split('-'),
                    segment_id_enabled = attr_name_parts[2],
                    passenger_id_enabled = attr_name_parts[3];

                callback_data.push(Object.assign({},
                    callback_data_item_base,
                    {
                        item_price: price_value,
                        passenger_id: passenger_id_enabled,
                        segment_id: segment_id_enabled,
                    }
                ));
            }
        }

        // if there is no selected passengers, hide "Reset all" button
        if (!that.getSegmentSelectedPassengers().length) {
            that.hideActionResetAll();
        }

        if (call_callback) {
            that.onPassengerReset(callback_data, call_callback_after, that);
        }

        if (call_callback_after) {
            that.afterPassengerReset(callback_data, that);
        }
    };

    UISelectSegmentPassengers.prototype.resetSegment = function () {
        var that = this,
            $segment_passenger_all = that.getSegmentPassengersAll();

        $segment_passenger_all.each(function () {
            var $segment_passenger = $(this),
                $selection = that.getPassengerSelection($segment_passenger),
                selection_id = that.getSelectionId($selection),
                selection_text = that.getSelectionText($selection),
                passenger_price = that.getPassengerPrice($segment_passenger),
                passenger_quantity = that.getPassengerQuantity($segment_passenger),
                passenger_quantity_min = that.isType(that.TYPES.counter) ? that.getPassengerCounterMin(passenger_id) : 0,
                passenger_id = that.getPassengerId($segment_passenger),
                callback_data,
                callback_data_item_base;

            if (
                that.isPassengerSelected($segment_passenger) &&
                (
                    !that.isPassengerDisabled($segment_passenger) ||
                    that.isSegmentTransfer()
                )
            ) {
                // clear all passenger state modifiers
                that.clearPassenger($segment_passenger);

                // shouldn't set passenger price in all-in-one mode - because it's different for all passengers
                if (!that.isAllInOne()) {
                    // clear passenger price
                    that.setPassengerPrice($segment_passenger, 0);
                }

                // clear passenger quantity
                that.setPassengerQuantity($segment_passenger, 0);

                // remove selected item from passenger block
                if (that.isType(that.TYPES.button)) {
                    that.__renderPassengerBadge($segment_passenger, 'empty');
                }

                // set `data-value` and value to counter (in case `reset()` was called from outside the component)
                if (that.isType(that.TYPES.counter)) {
                    that.setPassengerCounterValue($segment_passenger, passenger_quantity_min);
                }

                // set state to switch (in case `reset()` was called from outside the component)
                if (that.isType(that.TYPES.switch)) {
                    that.setPassengerSwitchValue($segment_passenger, false);
                }

                // callback
                callback_data_item_base = {
                    segment_id: that.segment_id,
                    item_id: selection_id,
                    item_price: passenger_price,
                    currency: that.currency,
                    item_quantity: 0,
                    item_quantity_diff: (passenger_quantity !== 0) ? -passenger_quantity : 0,
                };

                if (undefined !== selection_text) {
                    callback_data_item_base['item_text'] = selection_text;
                }

                if (!that.isAllInOne()) {
                    callback_data = Object.assign({},
                        callback_data_item_base,
                        {
                            passenger_id: passenger_id, 
                            segment_id: that.segment_id
                        }
                    );
                } else {
                    // for all-in-one mode callback data is array of objects
                    callback_data = [];

                    for (var price_attr_name in that.prices) {
                        var price_value = that.prices[price_attr_name],
                            attr_name_parts = price_attr_name.split('-'),
                            segment_id_enabled = attr_name_parts[2],
                            passenger_id_enabled = attr_name_parts[3];

                        callback_data.push(Object.assign({},
                            callback_data_item_base,
                            {
                                item_price: price_value,
                                passenger_id: passenger_id_enabled,
                                segment_id: segment_id_enabled,
                            }
                        ));
                    }
                }

                that.onPassengerReset(callback_data, true, that);
            }
        });

        // reset segment price
        that.setSegmentPrice(0);

        that.hideActionResetAll();

        that.afterSegmentReset(that.segment_id, that);
    };

    UISelectSegmentPassengers.prototype.resetPassenger = function (passenger_id, call_callback = true, call_callback_after = false) {
        var that = this,
            $select_passenger = that.getPassengerById(passenger_id),
            $selection = that.getPassengerSelection($select_passenger);
        if ($selection && $selection.length) {
            that.reset($selection, call_callback_after, call_callback);
        }
    };


    UISelectSegmentPassengers.prototype.setSegmentCurrent = function () {
        var that = this;
        that.$segment.addClass(that.class.segment_current);
    };

    UISelectSegmentPassengers.prototype.unsetSegmentCurrent = function ($segment = null) {
        var that = this;
        if (null === $segment) {
            $segment = that.$segment;
        }
        $segment.removeClass(that.class.segment_current);
    };

    // function only for readability, and for possible improvements in the future
    UISelectSegmentPassengers.prototype.expandSegment = function () {
        this.toggleSegment();
    };

    // function only for readability, and for possible improvements in the future
    UISelectSegmentPassengers.prototype.collapseSegment = function () {
        this.toggleSegment();
    };

    UISelectSegmentPassengers.prototype.toggleSegment = function () {
        var that = this;

        if (!that.isSegmentToggleDisabled()) {
            that.$segment_expand_button.click();
        }
    };

    UISelectSegmentPassengers.prototype.isSegmentExpanded = function () {
        var that = this;
        return that.$segment.hasClass(that.class.segment_expanded);
    };

    UISelectSegmentPassengers.prototype.isSegmentToggleDisabled = function () {
        var that = this;
        return that.$segment.hasClass(that.class.segment_toggle_disabled);
    };

    UISelectSegmentPassengers.prototype.isSegmentDisabled = function () {
        var that = this;
        return that.$segment.hasClass(that.class.segment_disabled);
    };

    UISelectSegmentPassengers.prototype.setPassengerSelected = function ($select_passenger) {
        var that = this;
        that.clearPassenger($select_passenger);
        $select_passenger.addClass(that.class.passenger_selected);
    };

    UISelectSegmentPassengers.prototype.unsetPassengerSelected = function ($select_passenger) {
        var that = this;
        $select_passenger.removeClass(that.class.passenger_selected);
    };

    UISelectSegmentPassengers.prototype.isPassengerSelected = function ($select_passenger) {
        var that = this;
        return $select_passenger.hasClass(that.class.passenger_selected);
    };

    UISelectSegmentPassengers.prototype.setPassengerFocused = function ($select_passenger) {
        var that = this;
        $select_passenger.addClass(that.class.passenger_focused);
    };

    UISelectSegmentPassengers.prototype.unsetPassengerFocused = function ($select_passenger) {
        var that = this;
        $select_passenger.removeClass(that.class.passenger_focused);
    };

    UISelectSegmentPassengers.prototype.setPassengerDisabled = function ($select_passenger) {
        var that = this;
        $select_passenger.addClass(that.class.passenger_disabled);
    };

    UISelectSegmentPassengers.prototype.unsetPassengerDisabled = function ($select_passenger) {
        var that = this;
        $select_passenger.removeClass(that.class.passenger_disabled);
    };

    UISelectSegmentPassengers.prototype.togglePassengerDisabled = function ($select_passenger, is_enabled) {
        var that = this;

        if (!is_enabled) {
            that.setPassengerDisabled($select_passenger);
        } else {
            that.unsetPassengerDisabled($select_passenger);
        }
    };

    UISelectSegmentPassengers.prototype.isPassengerDisabled = function ($select_passenger) {
        var that = this;
        return $select_passenger.hasClass(that.class.passenger_disabled);
    };

    UISelectSegmentPassengers.prototype.isPassengerSmartupSubscriber = function ($select_passenger) {
        var that = this;
        return $select_passenger.attr('data-' + that.data_keys.select_passenger_is_subscriber);
    };

    UISelectSegmentPassengers.prototype.setPassengerUnremovable = function ($select_passenger) {
        var that = this;
        $select_passenger.addClass(that.class.passenger_unremovable);
    };

    UISelectSegmentPassengers.prototype.isPassengerUnremovable = function ($select_passenger) {
        var that = this;
        return $select_passenger.hasClass(that.class.passenger_unremovable);
    };

    UISelectSegmentPassengers.prototype.__renderPassengerBadge = function ($select_passenger, state, badge_data = {}) {
        var that = this,
            $badge = $select_passenger.find(that.selectors.select_passenger_badge),
            method = '__renderPassengerBadge' + state.charAt(0).toUpperCase() + state.slice(1);
        if (UISelectSegmentPassengers.prototype.hasOwnProperty(method)) {
            UISelectSegmentPassengers.prototype[method].call(that, $badge, badge_data);
        }
    };

    UISelectSegmentPassengers.prototype.__renderPassengerBadgeSelected = function ($badge, badge_data = {}) {
        var that = this,
            $badge_text = $badge.find(that.selectors.select_passenger_badge_text),
            $badge_reset_btn = $badge.find(that.selectors.select_passenger_badge_reset_btn);

        that.__clearPassengerBadge($badge);

        // add state classes to badge
        $badge.addClass(that.class.badge_selected_classes);
        // set selection id
        that.setSelectionId($badge, badge_data['id'] || '');
        // set selection price
        that.setSelectionPrice($badge, badge_data['price'] || 0);
        // add state classes to badge text
        $badge_text.addClass(that.class.badge_selected_text_classes);
        // set badge text
        $badge_text.text(badge_data['text'] || '');
        // show reset button
        $badge_reset_btn.show();
    };

    UISelectSegmentPassengers.prototype.__renderPassengerBadgeEmpty = function ($badge, badge_data = {}) {
        var that = this,
            $badge_text = $badge.find(that.selectors.select_passenger_badge_text),
            badge_class = $.sa.is_desktop() ? that.class.badge_empty_desktop_classes : that.class.badge_empty_mobile_classes;

        that.__clearPassengerBadge($badge);

        // add state classes to badge
        $badge.addClass(badge_class);
        // set badge text
        $badge_text.text($.sa.locales['select']);
        // unset selection id
        that.unsetSelectionId($badge);
    };

    UISelectSegmentPassengers.prototype.__renderPassengerBadgeUnremovable = function ($badge, badge_data = {}) {
        var that = this,
            $badge_text = $badge.find(that.selectors.select_passenger_badge_text),
            $badge_reset_btn = $badge.find(that.selectors.select_passenger_badge_reset_btn);

        that.__clearPassengerBadge($badge);

        // add state classes to badge
        $badge.addClass(that.class.badge_unremovable_classes);
        // set selection id
        that.setSelectionId($badge, badge_data['id'] || '');
        // set selection price
        that.setSelectionPrice($badge, badge_data['price'] || 0);
        // add state classes to badge text
        $badge_text.addClass(that.class.badge_unremovable_text_classes);
        // set badge text
        $badge_text.text(badge_data['text'] || '');
        // hide reset button
        $badge_reset_btn.hide();
    };

    UISelectSegmentPassengers.prototype.__clearPassengerBadge = function ($badge) {
        var that = this,
            $badge_text = $badge.find(that.selectors.select_passenger_badge_text),
            $badge_reset_btn = $badge.find(that.selectors.select_passenger_badge_reset_btn);

        // remove state classes from badge
        $badge.removeClass(that.class.badge_selected_classes);
        $badge.removeClass(that.class.badge_empty_desktop_classes);
        $badge.removeClass(that.class.badge_empty_mobile_classes);
        $badge.removeClass(that.class.badge_unremovable_classes);
        // remove state classes from badge text
        $badge_text.removeClass(that.class.badge_selected_text_classes);
        $badge_text.removeClass(that.class.badge_unremovable_text_classes);
        // remove selection id
        that.setSelectionId($badge, '');
        // remove selection price
        that.setSelectionPrice($badge, '');
        // remove badge text content
        $badge_text.text('');
        // hide reset button
        $badge_reset_btn.hide();
    };

    /**
     * Removes all state modifiers from select_passenger.
     * @param $select_passenger
     */
    UISelectSegmentPassengers.prototype.clearPassenger = function ($select_passenger) {
        var that = this;
        that.unsetPassengerSelected($select_passenger);
        that.unsetPassengerFocused($select_passenger);
    };

    UISelectSegmentPassengers.prototype.countSegmentPrice = function () {
        var that = this,
            $select_passenger_all = that.getSegmentPassengersAll(),
            select_segment_passengers_price = 0;
        
        if (that.isType(that.TYPES.switch)) {
            $select_passenger_all = that.getSegmentSelectedPassengers();
        }

        if (!that.isAllInOne()) {
            $select_passenger_all.each(function () {
                var price = that.getPassengerPrice($(this));
                select_segment_passengers_price += price;
            });
        }
        // in all-in-one mode:
        // get all prices of all passengers and segments, and each of them multiply on quantity
        else {
            var quantity = that.getPassengerQuantity($select_passenger_all);
            for (var price_attr_name in that.prices) {
                var price = that.prices[price_attr_name];
                select_segment_passengers_price += (price * quantity);
            }
        }

        return select_segment_passengers_price;
    };

    UISelectSegmentPassengers.prototype.getSegmentPriceAndQuantity = function (segment_id) {
        var that = this,
            $select_passenger = that.getSegmentPassengersAll(),
            result = {price: 0, quantity: 0};

        if (!that.isAllInOne()) {
            return null;
        }

        var quantity = that.getPassengerQuantity($select_passenger);
        for (var price_attr_name in that.prices) {
            var price = that.prices[price_attr_name],
                attr_name_parts = price_attr_name.split('-'),
                segment_id_enabled = attr_name_parts[2];
            if (segment_id_enabled && segment_id_enabled.toString() === segment_id.toString()) {
                result.price += (price * quantity);
                result.quantity += quantity;
            }
        }
        return result;
    };

    UISelectSegmentPassengers.prototype.setSegmentPrice = function (price) {
        var that = this,
            price_formatted = $.sa.format.price(price, that.currency);

        // $segment_price do not exists if segment is disabled
        if (that.$segment_price.length) {
            that.$segment_price.text(price_formatted);
        }
    };

    UISelectSegmentPassengers.prototype.countSegmentQuantity = function () {
        var that = this,
            $select_passenger_all = that.$segment.find(that.selectors.select_passenger),
            select_segment_passengers_quantity = 0;

        $select_passenger_all.each(function () {
            var $passenger = $(this),
                passenger_quantity = that.getPassengerQuantity($passenger);
            select_segment_passengers_quantity += passenger_quantity;
        });

        return select_segment_passengers_quantity;
    };

    UISelectSegmentPassengers.prototype.hideActionResetAll = function () {
        var that = this,
            $actions_wrapper = that.$segment.find(that.selectors.select_passengers_actions),
            $action_reset_all = $actions_wrapper.find(that.selectors.select_passengers_action_reset);

        $action_reset_all.hide();
        
        // if there is no other actions but reset_all - hide actions wrapper too
        if ($action_reset_all.is(':only-child')) {
            $actions_wrapper.hide();
        }
    };

    UISelectSegmentPassengers.prototype.showActionResetAll = function () {
        var that = this,
            $actions_wrapper = that.$segment.find(that.selectors.select_passengers_actions),
            $action_reset_all = $actions_wrapper.find(that.selectors.select_passengers_action_reset);

        $action_reset_all.show();

        // if actions wrapper was hidden too - show it
        if ($actions_wrapper.is(':hidden')) {
            $actions_wrapper.show();
        }
    };

    UISelectSegmentPassengers.prototype.getSelectionId = function ($selection) {
        var that = this;
        return $selection.attr('data-' + that.data_keys.selection_id);
    };

    UISelectSegmentPassengers.prototype.setSelectionId = function ($selection, id) {
        var that = this;

        // restrict to modify selection id for counters and switches
        if (
            that.isType(that.TYPES.counter) ||
            that.isType(that.TYPES.switch)
        ) {
            return;
        }
        // DONT USE DATA - it would be ignored when clone to mobile drawer (and do not use $.clone(true) - it would also copy events)
        $selection.attr('data-' + that.data_keys.selection_id, id);
    };

    UISelectSegmentPassengers.prototype.unsetSelectionId = function ($selection) {
        var that = this,
            data_key = that.data_keys.hasOwnProperty('selection_' + that.type + '_id')
                ? that.data_keys['selection_' + that.type + '_id']
                : that.data_keys.selection_id;

        if (that.isType(that.TYPES.counter)) {
            return;
        }

        $selection.attr('data-' + data_key, '');
    };

    UISelectSegmentPassengers.prototype.getSelectionText = function ($selection) {
        var that = this;

        if (that.isType(that.TYPES.button)) {
            return $selection.find(that.selectors.select_passenger_badge_text).text();
        } else {
            return undefined;
        }
    };

    UISelectSegmentPassengers.prototype.getSelectionPrice = function ($selection) {
        var that = this,
            price = $selection.data(that.data_keys.selection_price);
        return price ? parseFloat(price) : 0;
    };

    UISelectSegmentPassengers.prototype.setSelectionPrice = function ($selection, price) {
        var that = this;
        // DONT USE DATA - it would be ignored when clone to mobile drawer (and do not use $.clone(true) - it would also copy events)
        $selection.attr('data-' + that.data_keys.selection_price, price);
    };

    UISelectSegmentPassengers.prototype.getPassengerSelectionId = function ($select_passenger) {
        var that = this,
            $selection = that.getPassengerSelection($select_passenger);

        return that.getSelectionId($selection);
    };

    UISelectSegmentPassengers.prototype.getPassengerSelectionPrice = function ($select_passenger) {
        var that = this,
            $selection = that.getPassengerSelection($select_passenger);

        return that.getSelectionPrice($selection);
    };

    UISelectSegmentPassengers.prototype.getPassengerSelection = function ($select_passenger) {
        var that = this;
        if (that.isType(that.TYPES.counter)) {
            return $select_passenger.find(that.selectors.select_passenger_counter);
        } else if (that.isType(that.TYPES.switch)) {
            return $select_passenger.find(that.selectors.select_passenger_switch);
        } else {
            return $select_passenger.find(that.selectors.select_passenger_selected_item);
        }
    };

    UISelectSegmentPassengers.prototype.getSelectionByPassengerId = function (passenger_id) {
        var that = this,
            $select_passenger = that.getPassengerById(passenger_id);
        return that.getPassengerSelection($select_passenger);
    };

    UISelectSegmentPassengers.prototype.isSelectionRelatesToPassenger = function ($select_passenger, selection_id) {
        var that = this,
            passenger_selection_id = that.getPassengerSelectionId($select_passenger);

        if (!selection_id) {
            return false;
        }
        // if selection_id matches passenger's selection id, or if selection id is not specified for that passenger
        if (!passenger_selection_id) {
            return true;
        }
        return passenger_selection_id.toString() === selection_id.toString();
    };

    UISelectSegmentPassengers.prototype.isAllInOne = function ($segment = null) {
        if (null === $segment) {
            $segment = this.$segment;
        }
        return !!$segment.data(this.data_keys.select_segment_all_in_one);
    };

    UISelectSegmentPassengers.prototype.getSegmentId = function ($segment = null) {
        var that = this;

        if (null === $segment) {
            $segment = that.$segment;
        }
        return !that.isAllInOne($segment)
            ? $segment.data(that.data_keys.select_segment_id)
            : $segment.data(that.data_keys.select_segment_ids);
    };

    UISelectSegmentPassengers.prototype.isThatSegment = function (segment_id) {
        var that = this;
        return that.segment_id.toString()
            .split(',')
            .includes(segment_id.toString());
    };

    UISelectSegmentPassengers.prototype.getSegmentCurrency = function () {
        return this.$segment.data(this.data_keys.select_segment_currency);
    };

    UISelectSegmentPassengers.prototype.getSegmentTypes = function () {
        var types = this.$segment.data(this.data_keys.select_segment_type);
        return types.split(',');
    };

    UISelectSegmentPassengers.prototype.isType = function (type) {
        return this.type.includes(type);
    };

    UISelectSegmentPassengers.prototype.isSegmentTransfer = function () {
        var that = this;
        return that.$segment.data(that.data_keys.select_segment_is_transfer);
    };

    UISelectSegmentPassengers.prototype.getSegmentDirectionIndex = function () {
        var that = this;
        return that.$segment.data(that.data_keys.select_segment_direction_index);
    };

    UISelectSegmentPassengers.prototype.getPassengerId = function ($select_passenger) {
        var that = this;
        return !that.isAllInOne()
            ? $select_passenger.data(that.data_keys.select_passenger_id)
            : $select_passenger.data(that.data_keys.select_passenger_ids);
    };

    UISelectSegmentPassengers.prototype.getPassengerSegmentId = function ($select_passenger) {
        return $select_passenger.data(this.data_keys.select_passenger_segment_id);
    };

    UISelectSegmentPassengers.prototype.getPassengerPrice = function ($select_passenger) {
        var that = this,
            data_price = $select_passenger.attr('data-' + this.data_keys.select_passenger_price);

        if (data_price) {
            return parseFloat(data_price);
        } else {
            return that.getPassengerSelectionPrice($select_passenger);
        }
    };

    UISelectSegmentPassengers.prototype.setPassengerPrice = function ($select_passenger, price) {
        // DONT USE DATA - it would be ignored when clone to mobile drawer (and do not use $.clone(true) - it would also copy events)
        $select_passenger.attr('data-' + this.data_keys.select_passenger_price, price);
    };

    /**
     * For all-in-one mode.
     * @returns {Object|null} Keys - data-attribute names, values - its values. 
     * Null - if not all-in-one mode or passenger selector was not found.
     */
    UISelectSegmentPassengers.prototype.getPassengerPrices = function () {
        var that = this;

        if (!that.isAllInOne()) {
            return null;
        }

        var select_passenger = that.getSegmentPassengersAll().get(0),
            price_attrs = {};

        if (!select_passenger) {
            return null;
        }

        // getting data-attributes with prefix 'data-price-'
        $(select_passenger.attributes).each(function() {
            var attr_name = this.nodeName;
            if (attr_name.indexOf('data-' + that.data_keys.select_passenger_price_item) > -1) {
                price_attrs[attr_name] = $(select_passenger).attr(attr_name);
            }
        });

        return price_attrs;
    };

    UISelectSegmentPassengers.prototype.getPassengerQuantity = function ($select_passenger) {
        var value = $select_passenger.attr('data-' + this.data_keys.select_passenger_quantity);
        return value ? parseInt(value, 10) : 0;
    };

    UISelectSegmentPassengers.prototype.setPassengerQuantity = function ($select_passenger, quantity) {
        // DONT USE DATA - it would be ignored when clone to mobile drawer (and do not use $.clone(true) - it would also copy events)
        $select_passenger.attr('data-' + this.data_keys.select_passenger_quantity, quantity);
    };

    UISelectSegmentPassengers.prototype.getPassengerCategoryCode = function ($select_passenger) {
        return $select_passenger.data(this.data_keys.select_passenger_category_code);
    };

    UISelectSegmentPassengers.prototype.getPassengerFirstname = function ($select_passenger) {
        return $select_passenger.data(this.data_keys.select_passenger_firstname);
    };

    UISelectSegmentPassengers.prototype.getPassengerLastname = function ($select_passenger) {
        return $select_passenger.data(this.data_keys.select_passenger_lastname);
    };

    UISelectSegmentPassengers.prototype.__getPassengerLiterals = function ($select_passenger) {
        var that = this,
            firstname = that.getPassengerFirstname($select_passenger) || '',
            lastname = that.getPassengerLastname($select_passenger) || '';
        return $.sa.nameLiterals(firstname, lastname);
    };

    UISelectSegmentPassengers.prototype.getPassengerHostId = function ($select_passenger) {
        return $select_passenger.data(this.data_keys.select_passenger_host_id);
    };

    UISelectSegmentPassengers.prototype.getPassengerHostParentId = function ($select_passenger) {
        return $select_passenger.data(this.data_keys.select_passenger_host_parent_id);
    };

    UISelectSegmentPassengers.prototype.getPassengerHostChildId = function ($select_passenger) {
        return $select_passenger.data(this.data_keys.select_passenger_host_child_id);
    };

    UISelectSegmentPassengers.prototype.getPassengerById = function (passenger_id) {
        var that = this;
        return !that.isAllInOne()
            ? that.$segment.find(that.selectors.select_passenger + '[data-' + that.data_keys.select_passenger_id + '="' + passenger_id + '"]')
            : that.$segment.find(that.selectors.select_passenger); // in all-in-one mode one passenger selector relates to all passengers
    };

    /**
     * Defines if specified two passenger ids are related to the same passenger
     * @param {*} passenger_id_1
     * @param {*} passenger_id_2
     * @returns {boolean}
     */
    UISelectSegmentPassengers.prototype.isTheSamePassenger = function (passenger_id_1, passenger_id_2) {
        // convert to string to compare with strict type
        if (!Array.isArray(passenger_id_1)) {
            passenger_id_1 = passenger_id_1 ? passenger_id_1.toString() : '';
            // if passenger_id is stringified array, convert it to array of strings
            if (passenger_id_1.includes(',')) {
                passenger_id_1 = passenger_id_1.split(',');
            }
        }
        if (!Array.isArray(passenger_id_2)) {
            passenger_id_2 = passenger_id_2 ? passenger_id_2.toString() : '';
            if (passenger_id_2.includes(',')) {
                passenger_id_2 = passenger_id_2.split(',');
            }
        }

        if (Array.isArray(passenger_id_1)) {
            if (Array.isArray(passenger_id_2)) {
                // if both passenger_ids are arrays - they are both values of data-attribute `passenger-ids`,
                // which is forming in cycle from the same array of passengers; so they must be the same
                return passenger_id_1.toString() === passenger_id_2.toString();
            } else {
                return passenger_id_1.includes(passenger_id_2);
            }
        } else {
            if (Array.isArray(passenger_id_2)) {
                return passenger_id_2.includes(passenger_id_1);
            } else {
                return passenger_id_1 === passenger_id_2;
            }
        }
    };

    UISelectSegmentPassengers.prototype.getSegmentPassengersAll = function () {
        var that = this;
        return that.$segment.find(that.selectors.select_passenger);
    };

    UISelectSegmentPassengers.prototype.getSegmentFirstPassenger = function () {
        var that = this;
        return that.getSegmentPassengersAll().first();
    };

    UISelectSegmentPassengers.prototype.getSegmentLastPassenger = function () {
        var that = this;
        return that.getSegmentPassengersAll().last();
    };

    UISelectSegmentPassengers.prototype.getSegmentPassengersUnselected = function ($segment = null)
    {
        var that = this;
        if (null === $segment) {
            $segment = that.$segment;
        }
        return $segment.find(
            that.selectors.select_passenger +
            ':not(.' + that.class.passenger_selected + ')' +
            ':not(.' + that.class.passenger_disabled + ')'
        );
    };

    UISelectSegmentPassengers.prototype.getSegmentSelectedPassengers = function () {
        var that = this;
        return that.$segment.find(that.selectors.select_passenger_selected);
    };

    UISelectSegmentPassengers.prototype.getNextUnselectedSegmentPassenger = function ($select_passenger) {
        var that = this,
            $next_select_passengers = that.__getSegmentPassengersAfter($select_passenger);

        return $next_select_passengers
            .filter(':not(.' + that.class.passenger_selected + ')')
            .first();
    };

    UISelectSegmentPassengers.prototype.getPreviousUnselectedSegmentPassenger = function ($select_passenger) {
        var that = this,
            $previous_select_passengers = that.__getSegmentPassengersBefore($select_passenger);

        // get first unselected passenger which is above current one
        return $previous_select_passengers
            .filter(':not(.' + that.class.passenger_selected + ')')
            .last();
    };

    UISelectSegmentPassengers.prototype.getNextSegmentPassenger = function ($select_passenger) {
        var that = this,
            $next_select_passengers = that.__getSegmentPassengersAfter($select_passenger);
        return $next_select_passengers.first();
    };

    UISelectSegmentPassengers.prototype.getPreviousSegmentPassenger = function ($select_passenger) {
        var that = this,
            $previous_select_passengers = that.__getSegmentPassengersBefore($select_passenger);
        return $previous_select_passengers.last();
    };

    UISelectSegmentPassengers.prototype.__getSegmentPassengersAfter = function ($select_passenger) {
        var that = this,
            $select_passenger_all = that.getSegmentPassengersAll(),
            select_passenger_index = $select_passenger_all.index($select_passenger),
            $select_passenger_siblings_after = $select_passenger_all.slice(select_passenger_index + 1); // if element not found, index would be -1, so slice would be copy of initial set

        return $select_passenger_siblings_after.filter(
            ':not(.' + that.class.passenger_disabled + ')'
        );
    };

    UISelectSegmentPassengers.prototype.__getSegmentPassengersBefore = function ($select_passenger) {
        var that = this,
            $select_passenger_all = that.getSegmentPassengersAll(),
            select_passenger_index = $select_passenger_all.index($select_passenger),
            $select_passenger_siblings_before = $select_passenger_all.slice(0, select_passenger_index);

        // get first unselected passenger which is above current one
        return $select_passenger_siblings_before.filter(
            ':not(.' + that.class.passenger_disabled + ')'
        );
    };

    UISelectSegmentPassengers.prototype.getFirstUnselectedSegmentPassenger = function ($segment = null) {
        var that = this,
            $unselected_segment_passengers = that.getSegmentPassengersUnselected($segment);
        return $unselected_segment_passengers.first();
    };

    UISelectSegmentPassengers.prototype.getLastUnselectedSegmentPassenger = function ($segment = null) {
        var that = this,
            $unselected_segment_passengers = that.getSegmentPassengersUnselected($segment);
        return $unselected_segment_passengers.last();
    };

    UISelectSegmentPassengers.prototype.getFirstUnselectedPassengerNextSegment = function () {
        var that = this,
            segment_index = that.$segments_all.index(that.$segment),
            segments_after = that.$segments_all.slice(segment_index + 1); // if element not found, index would be -1, so slice would be copy of initial set

        for (var i = 0; i < segments_after.length; i++) {
            var $segment_after = $(segments_after[i]),
                $first_unselected_passenger = that.getFirstUnselectedSegmentPassenger($segment_after);
            if ($first_unselected_passenger.length) {
                return $first_unselected_passenger;
            }
        }
        return [];
    };

    UISelectSegmentPassengers.prototype.setPassengerBadgeValue = function (
        $select_passenger,
        item_quantity,
        item_data
    ) {
        var that = this,
            badge_state = item_quantity > 0 ? 'selected' : 'empty';

        that.__renderPassengerBadge($select_passenger, badge_state, item_data);
    };

    UISelectSegmentPassengers.prototype.getUnselectedPassengers = function () {
        var that = this;
        return that.$segments_all.find(
            that.selectors.select_passenger + 
            ':not(.' + that.class.passenger_selected + ')' +
            ':not(.' + that.class.passenger_disabled + ')'
        );
    };

    UISelectSegmentPassengers.prototype.getPassengersAll = function () {
        var that = this;
        return that.$segments_all.find(that.selectors.select_passenger);
    };


    /**
     * @throws CounterValueIsOutOfRangeError|CounterInvalidValueError
     */
    UISelectSegmentPassengers.prototype.setPassengerCounterValue = function (
        $select_passenger, 
        value, 
        set_input_value = true
    ) {
        var that = this,
            $counter = that.getPassengerSelection($select_passenger);

        value = parseInt(value, 10);

        // DONT USE DATA - it would be ignored when clone to mobile drawer
        $counter.attr('data-' + that.data_keys.select_passenger_counter_value, value);

        if (set_input_value && that.getCounterValue($counter) !== value) {
            // do not trigger value_changed event - would be recursive call of select()!
            that.setCounterValue($counter, value, true, false);
        }
    };

    /**
     * @param $select_passenger
     * @param {Boolean} value
     */
    UISelectSegmentPassengers.prototype.setPassengerSwitchValue = function (
        $select_passenger, 
        value
    ) {
        var that = this,
            $switch = that.getPassengerSelection($select_passenger),
            $switch_checkbox = $switch.find(that.selectors.select_passenger_switch_checkbox),
            is_checked_current = !!$switch_checkbox.attr('checked');

        if (is_checked_current !== value) {
            if (value) {
                // USE PROP BECAUSE ATTR WORKS INCORRECTLY IN BROWSERS
                $switch_checkbox.prop('checked', true);
                // USE ATTR ALONG WITH PROP - because prop would be ignored when clone to mobile drawer
                $switch_checkbox.attr('checked', 'checked');
            } else {
                $switch_checkbox.prop('checked', false);
                $switch_checkbox.removeAttr('checked');
            }
        }
    };

    /**
     * @param {jQuery} $select_passenger
     * @param {Object} selection_data
     */
    UISelectSegmentPassengers.prototype.setPassengerSelectionUnremovable = function ($select_passenger, selection_data = {}) {
        var that = this,
            $selection = that.getPassengerSelection($select_passenger);

        that.setPassengerUnremovable($select_passenger);

        if (that.isType(that.TYPES.button)) {
            that.__renderPassengerBadge($select_passenger, 'unremovable', selection_data);
        }

        if (that.isType(that.TYPES.counter)) {
            var min_value = selection_data.min_value || 0;
            that.setCounterMin($selection, min_value, true, true);
        }

        if (that.isType(that.TYPES.switch)) {
            var $switch_checkbox = $selection.find(that.selectors.select_passenger_switch_checkbox);

            // USE PROP BECAUSE ATTR WORKS INCORRECTLY IN BROWSERS
            $switch_checkbox.prop('disabled', true);
            // USE ATTR ALONG WITH PROP - because prop would be ignored when clone to mobile drawer
            $switch_checkbox.attr('disabled', 'disabled');
        }

        if (that.isType(that.TYPES.checkbox)) {
            // TODO
        }
    };

    UISelectSegmentPassengers.prototype.getPassengerCounterMin = function (passenger_id) {
        var that = this;

        if (!that.isType(that.TYPES.counter)) {
            return;
        }

        return that.getCounterMin(that.getSelectionByPassengerId(passenger_id));
    };

    UISelectSegmentPassengers.prototype.getPassengerCounterMax = function (passenger_id) {
        var that = this;

        if (!that.isType(that.TYPES.counter)) {
            return;
        }

        return that.getCounterMax(that.getSelectionByPassengerId(passenger_id));
    };

    UISelectSegmentPassengers.prototype.getPassengerCounterValue = function (passenger_id) {
        var that = this;

        if (!that.isType(that.TYPES.counter)) {
            return;
        }

        return that.getCounterValue(that.getSelectionByPassengerId(passenger_id));
    };


    UISelectSegmentPassengers.prototype.getCounterMin = function ($counter) {
        if (!$counter || !$counter.length) {
            return;
        }
        return UICounter.prototype.getMin($counter);
    };

    UISelectSegmentPassengers.prototype.getCounterMax = function ($counter) {
        if (!$counter || !$counter.length) {
            return;
        }
        return UICounter.prototype.getMax($counter);
    };

    UISelectSegmentPassengers.prototype.getCounterValue = function ($counter) {
        if (!$counter || !$counter.length) {
            return;
        }
        return UICounter.prototype.getValue($counter);
    };

    /**
     * @throws CounterValueIsOutOfRangeError|CounterInvalidValueError
     */
    UISelectSegmentPassengers.prototype.setCounterValue = function (
        $counter,
        value,
        check_limits = true,
        trigger_event = true
    ) {
        if (!$counter || !$counter.length) {
            return;
        }

        UICounter.prototype.set($counter, value, check_limits, trigger_event);
    };

    UISelectSegmentPassengers.prototype.setCounterMax = function (
        $counter, 
        counter_max = null, 
        check_min = true
    ) {
        if (!$counter || !$counter.length) {
            return;
        }

        try {
            UICounter.prototype.setMax($counter, counter_max, check_min);
        } catch (e) {
            if (e instanceof CounterMaxLessThanMinError) {
                $.sa.error('Trying to set counter max value to the out of range value.');
            } else {
                $.sa.error(e);
            }
        }
    };

    UISelectSegmentPassengers.prototype.setCounterMin = function (
        $counter, 
        counter_min = null, 
        check_max = true
    ) {
        if (!$counter || !$counter.length) {
            return;
        }

        try {
            UICounter.prototype.setMin($counter, counter_min, check_max);
        } catch (e) {
            if (e instanceof CounterMinGreaterThanMaxError) {
                $.sa.error('Trying to set counter min value to the out of range value.');
            } else {
                $.sa.error(e);
            }
        }
    };

    return UISelectSegmentPassengers;
})($);